import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const NavItem = props => {
    const classes = classNames(['nav-item', props.className, props.active ? 'active' : '']);
    return _jsx("li", Object.assign({ className: classes }, { children: props.children }));
};
